/* Fransk katalog for locale-no.js (del 7 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'bg.balanceDiscrepancy': 'Écart de solde',
  'bg.notCorrect': 'Incorrect',
  'bg.reconciliationDone': 'Le rapprochement bancaire est terminé',
  'bg.reconciliationDoneHelp': 'Le relevé a été vérifié, comptabilisé et archivé.',
  'bg.bankLines': 'Lignes bancaires',
  'bg.reconciled': 'Rapproché',
  'bg.backToBank': 'Retour à Banque',
  'bg.reopenReconciliation': 'Rouvrir le rapprochement',
  'bg.bankAccountCaps': 'COMPTE BANCAIRE',
  'bg.periodCaps': 'PÉRIODE',
  'bg.balanceAtStart': 'Solde au début de la période',
  'bg.balanceAtEnd': 'Solde à la fin de la période',
  'bg.balancesMatch': 'Les soldes concordent.',
  'bg.roundingHelp': 'Ceci peut être comptabilisé sur le compte d\'arrondi 7770 sans modifier le montant du relevé bancaire.',
  'bg.balancesMatchContinue': 'Les soldes concordent – continuer',
  'bg.suggestionsHeading': 'SuperPlumma a rapproché et proposé des écritures — c\'est vous qui décidez',
  'bg.noSuggestions': 'Aucune proposition en attente d\'approbation.',
  'bg.continueToRest': 'Continuer avec le reste',
  'bg.noPostedDiscrepancies': 'Aucune écriture comptabilisée ne crée d\'écart.',
  'bg.checkAndFix': 'Vérifiez et corrigez les écritures avant de finaliser la période.',
  'bg.allPaymentsHandled': 'Tous les paiements ont été traités.',
  'bg.continueToVouchers': 'Continuer vers les justificatifs',
  'bg.allPurchasesDocumented': 'Tous les achats ont la documentation nécessaire ou sont marqués sans justificatif.',
  'bg.seePurchase': 'Voir l\'achat',
  'bg.withoutVoucher': 'Sans justificatif',
  'bg.linkSuggested': 'Lier la proposition',
  'bg.pickVoucher': 'Choisir un justificatif',
  'bg.continueToFinish': 'Continuer vers la finalisation',
  'bg.bankLinesTotal': 'Total des lignes bancaires',
  'bg.linkedPosted': 'Lié/comptabilisé',
  'bg.privateMovements': 'Mouvements privés',
  'bg.reconcileAndArchive': 'Rapprocher et archiver',
  'bg.backAndCheck': 'Revenir et vérifier',
  'bg.stepModeHelp': 'Le mode pas à pas vous guide dans une tâche à la fois. La vue complète affiche tout ensemble.',
  'acc.sub': 'Votre profil et les entreprises auxquelles vous avez accès.',
  'acc.signOutHelp': 'Vous déconnecte de Plumme. Vous devrez vous reconnecter avec votre e-mail et votre mot de passe pour continuer.',
  'acc.yourRole': 'Votre rôle',
  'acc.yourRoleHelp': 'Le rôle détermine ce que vous pouvez faire : le Propriétaire a un accès complet, l\'Administrateur gère l\'exploitation, le Comptable tient la comptabilité et le Lecteur peut seulement consulter. Le rôle peut varier d\'une entreprise à l\'autre.',
  'acc.editProfile': 'Modifier le profil',
  'acc.myBusinesses': 'Mes entreprises',
  'acc.myBusinessesHelp': 'Les entreprises auxquelles vous avez accès dans Plumme. L\'étiquette indique votre rôle dans chacune. Touchez une entreprise pour ouvrir sa comptabilité.',
  'acc.personalFinanceHelp': 'Finances personnelles est un type de client distinct pour les finances personnelles et du foyer, séparé de la comptabilité des entreprises.',
  'acc.goToPersonalFinance': 'Aller aux finances personnelles',
  'acc.ownPersonalClient': 'Client Finances personnelles propre',
  'acc.myEmployers': 'Mes employeurs',
  'acc.myEmployersHelp': 'Entreprises qui vous emploient (dont vous ne tenez pas forcément la comptabilité). Vous y trouverez progressivement bulletins de paie, contrats et votre propre page salarié.',
  'acc.employerPortalAccess': 'Entreprises pour lesquelles vous avez accès au portail salarié.',
  'acc.changePicture': 'Changer la photo',
  'acc.removePicture': 'Supprimer la photo',
  'acc.photoUploading': 'Importation …',
  'acc.photoRemoving': 'Suppression …',
  'acc.photoSaved': 'La photo de profil a été mise à jour.',
  'acc.photoRemoved': 'La photo de profil a été supprimée.',
  'acc.photoWrongType': 'Choisissez une image PNG, JPG ou WebP.',
  'acc.photoEmpty': 'Le fichier image est vide.',
  'acc.photoTooLarge': 'L\'image est trop volumineuse. 2 MB maximum.',
  'acc.photoUploadFailed': 'Impossible d\'importer la photo de profil.',
  'acc.photoRemoveFailed': 'Impossible de supprimer la photo de profil.',
  'acc.photoUnavailable': 'La photo de profil n\'est pas disponible pour le moment.',
  'acc.fullName': 'Nom complet',
  'acc.phoneFromLogin': 'Téléphone de connexion',
  'acc.changePassword': 'Modifier le mot de passe',
  'acc.changes': 'Modifications',
  'acc.noChangeDetails': 'Aucun détail de modification supplémentaire n\'est enregistré pour cet événement.',
  'acc.logSub': 'Ce qui a été fait dans la comptabilité - et par qui.',
  'acc.logFilterHelp': 'Filtrez le journal par période, domaine (p. ex. Facture, Paie, TVA) et utilisateur ayant effectué l\'action.',
  'acc.area': 'Domaine',
  'acc.areaHelp': 'La partie de la comptabilité concernée par l\'action - p. ex. Facture, Achat, Paie ou TVA. Une action peut toucher plusieurs domaines.',
  'acc.user': 'Utilisateur',
  'acc.userHelp': 'La personne qui a effectué l\'action, avec son rôle. Vous voyez ainsi qui est à l\'origine de chaque modification.',
  'acc.sentLinkTo': 'Nous avons envoyé un lien à',
  'bud.annualBudget': 'Budget annuel',
  'bud.suggestion': 'Proposition de budget',
  'bud.createSuggestion': 'Créer une proposition',
  'bud.startSimpleQuestions': 'Commencer par des questions simples',
  'bud.fillRelevant': 'Remplissez uniquement ce qui est pertinent. Les montants mensuels sont convertis en budget annuel.',
  'bud.businessDescription': 'Description de l\'activité',
  'bud.businessDescriptionPh': 'Ex. agence de transport pour 2027 avec 2 utilitaires, 2 salariés, un loyer de bureau de 8 000/mois et plus de revenus en été.',
  'bud.howToBudget': 'Comment créer un budget',
  'bud.howToBudgetHelp': 'Choisissez une méthode : avec « Manuel », vous saisissez vous-même les comptes, avec « Proposition », vous répondez à quelques questions simples et obtenez un brouillon, et avec « Proposition IA », vous décrivez l\'activité avec vos propres mots et Plumme crée un brouillon.',
  'bud.budgetedResult': 'Résultat budgété',
  'bud.budgetedResultHelp': 'Le résultat budgété pour toute l\'année — produits budgétés moins charges budgétées. C\'est l\'objectif vers lequel vous tendez.',
  'bud.actualResult': 'Résultat réel',
  'bud.actualResultHelp': 'Le résultat réel comptabilisé depuis le début de l\'année — produits réels moins charges réelles. Comparez-le au budget pour voir si vous êtes dans les clous.',
  'bud.postedSoFar': 'comptabilisé à ce jour',
  'bud.varianceToPeriod': 'Écart sur la période',
  'bud.varianceToPeriodHelp': 'La différence entre le résultat réel et le résultat budgété à ce jour. Un écart négatif signifie que vous êtes en dessous du budget, un écart positif au-dessus.',
  'bud.incomeTarget': 'Objectif de chiffre d\'affaires',
  'bud.incomeTargetHelp': 'La part des produits budgétés de l\'année atteinte jusqu\'ici — produits réellement facturés divisés par les produits budgétés.',
  'bud.ofTargetReached': 'de l\'objectif atteint',
  'bud.viewHelp': 'Changez de vue : « Vue d\'ensemble » montre le résultat cumulé et le plus grand écart, « Analyse » montre produits et charges ainsi que le résultat par mois, et « Budget par catégorie » est l\'endroit où vous saisissez et modifiez les montants.',
  'bud.accumulatedResult': 'Résultat cumulé',
  'bud.accumulatedResultHelp': 'Le graphique montre le résultat qui se construit mois après mois au fil de l\'année. La ligne pointillée est le budget, la ligne continue le réel comptabilisé — vous voyez ainsi si vous suivez le plan.',
  'bud.budgetAtYearEnd': 'Budget en fin d\'année',
  'bud.accumulated': 'cumulé',
  'bud.actualSoFar': 'Réel à ce jour',
  'bud.posted': 'comptabilisé',
  'bud.varianceSoFar': 'Écart à ce jour',
  'bud.largestVariance': 'Écart le plus important',
  'bud.largestVarianceHelp': 'Le compte qui s\'écarte le plus du budget depuis le début de l\'année. Utile pour voir rapidement où vous dépassez le plus ou restez le plus en deçà de vos prévisions.',
  'bud.soFarThisYear': 'depuis le début de l\'année',
  'bud.incomeVsCost': 'Produits vs charges par mois',
  'bud.incomeVsCostHelp': 'Les barres montrent les produits (vert) face aux charges (orange) pour chaque mois. Basculez entre chiffres réels, chiffres budgétés ou les deux. Touchez un mois pour totaliser une sélection.',
  'bud.resultPerMonth': 'Résultat par mois',
  'bud.resultPerMonthHelp': 'Affiche le résultat (produits moins charges) pour chaque mois, budget face au réel. Les barres au-dessus de la ligne médiane sont un bénéfice, en dessous une perte.',
  'bud.actual': 'Réel',
  'bud.actualByCategory': 'Réel par catégorie',
  'bud.actualByCategoryHelp': 'Produits et charges comptabilisés par compte, répartis par mois. Les chiffres proviennent de votre comptabilité — justificatifs saisis dans Plumme comme chiffres importés — et se mettent à jour automatiquement.',
  'bud.noActuals': 'Aucun chiffre comptabilisé pour {year} pour l\'instant.',
  'bud.actualOnlyHint': 'Ce sont des chiffres réels. Saisissez un budget sous Budget si vous voulez vous mesurer à un plan.',
  'bud.byCategory': 'Budget par catégorie',
  'bud.addIncome': 'Ajouter un produit',
  'bud.addIncomeHelp': 'Ajoutez une catégorie de produits avec un montant annuel — par ex. les ventes attendues. Le montant est réparti sur les mois, et vous pouvez l\'ajuster.',
  'bud.addCost': 'Ajouter une charge',
  'bud.addCostHelp': 'Ajoutez une catégorie de charges avec un montant annuel — par ex. loyer, achats de marchandises ou logiciels. Le montant est réparti sur les mois, et vous pouvez l\'ajuster.',
  'bud.noCategories': 'Aucune catégorie budgétaire pour l\'instant. Ajoutez un produit ou une charge.',
  'bud.useLastYear': 'Utiliser l\'année précédente',
  'bud.simpleQuestions': 'Questions simples',
  'bud.byCategoryHelp': 'Chaque ligne est une catégorie budgétaire. Les montants des 12 mois sont toujours visibles et modifiables directement dans le tableau, avec le total annuel à droite.',
  'bud.total': 'Total',
  'bud.annualTotal': 'Total annuel',
  'bud.annualTotalHelp': 'Si vous modifiez directement ce chiffre, le nouveau montant annuel est réparti uniformément sur les 12 mois.',
  'bud.save': 'Enregistrer',
  'bud.methodManual': 'Manuel',
  'bud.methodSuggestion': 'Suggestion',
  'bud.methodAi': 'Suggestion IA',
  'bud.modeBudgeted': 'Budgété',
  'bud.modeBoth': 'Les deux',
  'bud.forWholeYear': 'pour toute l\'année {year}',
  'bud.underBudget': 'sous le budget',
  'bud.overBudget': 'au-dessus du budget',
  'bud.legendBudgetDashed': '- - Budget',
  'bud.legendBudgetSolid': '— Budget',
  'bud.legendActual': '— Réel',
  'bud.noVarianceYet': 'Aucun écart pour l\'instant',
  'bud.savedToast': 'Budget enregistré',
  'bud.saveFailedToast': 'Impossible d\'enregistrer le budget',
  'bud.aiModalTitle': 'Budget IA pour {year}',
  'bud.aiDraftBusy': 'Création du brouillon...',
  'bud.aiDraftCreate': 'Créer un brouillon avec l\'IA',
  'bud.aiDescription': 'Décrivez l\'entreprise avec vos propres mots : salariés, salaires, actifs, charges fixes et saisonnalité. Plus il y a de détails, meilleur sera le brouillon.',
  'bud.aiDraftFailedGeneric': 'Je n\'ai pas pu créer de brouillon de budget à partir de la description. Ajoutez plus de détails ou utilisez Suggestion.',
  'bud.aiDraftAppliedToast': 'Brouillon IA ajouté. Appuyez sur Enregistrer quand il vous convient.',
  'bud.aiDraftFailed': 'Échec du brouillon de budget IA.',
  'bud.suggestionIntro': 'Créez une suggestion à partir des chiffres réels de l\'an dernier, ou répondez à quelques questions simples pour un budget de départ.',
  'bud.catSales': 'Ventes de biens et services',
  'bud.catPurchases': 'Achats de marchandises et coûts directs',
  'bud.catPremises': 'Locaux',
  'bud.catSoftware': 'Logiciels et équipement',
  'bud.catAccounting': 'Comptabilité et conseil',
  'bud.catTravel': 'Déplacements',
  'bud.catMarketing': 'Marketing',
  'bud.catCommunication': 'Téléphone, affranchissement et communication',
  'bud.otherCosts': 'Autres charges',
  'bud.customCategory': 'Catégorie personnalisée',
  'bud.q.expectedIncome.label': 'Combien prévoyez-vous de gagner ?',
  'bud.q.expectedIncome.hint': 'Produits facturés attendus pour toute l\'année.',
  'bud.q.goodsAnnual.label': 'Achats de marchandises',
  'bud.q.goodsAnnual.hint': 'Marchandises ou matériel que vous achetez pour la revente.',
  'bud.q.officeMonthly.label': 'Bureau/locaux par mois',
  'bud.q.officeMonthly.hint': 'Loyer, espace de bureau ou locaux.',
  'bud.q.softwareMonthly.label': 'Logiciels par mois',
  'bud.q.softwareMonthly.hint': 'Abonnements, outils et applications.',
  'bud.q.accountingMonthly.label': 'Comptabilité/conseil par mois',
  'bud.q.accountingMonthly.hint': 'Comptable, conseiller ou autre aide.',
  'bud.q.travelAnnual.label': 'Voiture/déplacements par an',
  'bud.q.travelAnnual.hint': 'Trajets, voyages, hôtel ou transport.',
  'bud.q.marketingAnnual.label': 'Marketing par an',
  'bud.q.marketingAnnual.hint': 'Annonces, image de marque et frais commerciaux.',
  'bud.q.otherAnnual.hint': 'Prévoyez une marge pour ce que vous ne savez pas encore.',
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Demander à SuperPlumma',
  'aii.chatWithSuperPlumma': 'Discuter avec SuperPlumma',
  'aii.chatWithMe': 'Discutez avec moi',
  'aii.healthScore': 'Score de santé financière',
  'po.title': 'Finances personnelles',
  'po.backToBusiness': 'Retour à l\'entreprise',
  'po.yourAdvisor': 'Votre conseiller personnel',
  'po.intro': 'Les finances personnelles concernent votre économie privée — entièrement séparée de la comptabilité de l\'entreprise. SuperPlumma analyse les revenus, les dépenses, l\'épargne, les prêts, la retraite et les impôts du foyer, et vous conseille comme le ferait un conseiller financier personnel. « Bêta » signifie que la fonctionnalité est encore en développement.',
  'po.hero.greeting.night': 'Bonne nuit.',
  'po.hero.greeting.morning': 'Bonjour.',
  'po.hero.greeting.day': 'Bonjour.',
  'po.hero.greeting.evening': 'Bonsoir.',
  'po.hero.greetingNamed.night': 'Bonne nuit, {name}.',
  'po.hero.greetingNamed.morning': 'Bonjour, {name}.',
  'po.hero.greetingNamed.day': 'Bonjour, {name}.',
  'po.hero.greetingNamed.evening': 'Bonsoir, {name}.',
  'po.hero.section.idag': 'Conseil du jour',
  'po.hero.section.oversikt': 'Aperçu financier',
  'po.hero.section.forbruk': 'Dépenses',
  'po.hero.section.familie': 'Finances familiales',
  'po.hero.section.fremtid': 'Plan d\'avenir',
  'po.hero.section.reports': 'Rapports',
  'po.hero.section.assets': 'Patrimoine',
  'po.hero.section.gjeld': 'Dettes',
  'po.hero.section.import': 'Base de données',
  'po.hero.advice.idag': 'Je suis vos finances de près et mets en avant les tâches et opportunités les plus importantes en ce moment.',
  'po.hero.advice.oversikt': 'Voyez ce qui fait monter et baisser votre santé financière. Commencez par le domaine qui demande le plus de suivi.',
  'po.hero.advice.forbruk': 'Repérez les catégories en hausse et choisissez une mesure réaliste qui vous donne plus de marge sans trop serrer le quotidien.',
  'po.hero.advice.familie': 'Clarifiez ce qui est commun, qui paie quoi et quels objectifs le foyer doit prioriser ensemble.',
  'po.hero.advice.fremtid': 'Rendez vos objectifs concrets avec un montant et une date. Il sera alors plus facile de voir combien épargner chaque mois.',
  'po.hero.advice.reports': 'Utilisez les rapports pour comprendre l\'évolution dans le temps, pas seulement un mois isolé particulièrement élevé ou bas.',
  'po.hero.advice.assets': 'Vérifiez que les valeurs et soldes de comptes sont à jour avant d\'évaluer votre patrimoine net et vos choix à long terme.',
  'po.hero.advice.gjeld': 'Constituez d\'abord une réserve de sécurité, puis envisagez des remboursements anticipés sur la dette au taux effectif le plus élevé.',
  'po.hero.advice.import': 'Un bon conseil commence par de bonnes données. Associez les relevés au bon compte et comblez les périodes manquantes.',
  'po.pickPerson': 'Choisir une personne',
  'po.sections': 'Sections',
  'po.sectionsHelp': 'Passez d\'un domaine à l\'autre : Aujourd\'hui (aperçus du jour), Aperçu (score de santé et indicateurs clés), Dépenses (où va l\'argent), Famille, Avenir (prévision et « et si »), Rapports, Patrimoine, Dettes, Impôts et Import.',
  'po.outOf100': 'sur 100',
  'po.todaysFocus': 'Priorité du jour',
  'po.todaysTasks': 'Tâches du jour',
  'po.mostImportantToday': 'Le plus important aujourd\'hui',
  'po.markDone': 'Marquer comme terminé',
  'po.undo': 'Annuler',
  'po.healthHeading': 'Votre santé financière globale — et ce qui la fait évoluer',
  'po.healthHelp': 'Le nombre dans l\'anneau (0–100) est une évaluation globale de vos finances — plus il est élevé, plus elles sont saines. Les catégories ci-dessous montrent ce qui le fait monter ou baisser : le vert est bon, l\'orange signifie à surveiller, et le rouge nécessite une action.',
  'po.noHistory': 'Aucun historique de comparaison pour le moment',
  'po.whatAffectsScore': 'Ce qui influence le plus le score',
  'po.noDrivers': 'Aucun facteur calculé pour le moment',
  'po.noDriversHelp': 'Dès qu\'il y aura assez de transactions importées, je vous montrerai ce qui fait monter ou baisser le score.',
  'po.last30Days': 'Dernier mois enregistré',
  'po.last30DaysSub': 'Par rapport au mois civil précédent',
  'po.financialOverview': 'Aperçu financier',
  'po.financialOverviewSub': 'Un instantané des finances du foyer',
  'po.recommendations': 'Recommandations de SuperPlumma',
  'po.recommendationsSub': 'Les mesures qui comptent le plus pour vos finances en ce moment',
  'po.askMe': 'Demandez-moi',
  'po.yourHealthScoreIs': 'Votre score de santé est',
  'po.adjustBudget': 'Ajuster le budget',
  'po.budgetTotal': 'Total du budget :',
  'po.saveBudget': 'Enregistrer le budget',
  'po.monthlyLimitPerCategory': 'Limite mensuelle par catégorie',
  'po.noCategoriesImported': 'Aucune catégorie de dépenses importée pour le moment. Ajoutez vos propres catégories ci-dessous.',
  'po.ownCategories': 'Catégories personnelles',
  'po.pickColour': 'Choisir une couleur',
  'po.categoryName': 'Nom de la catégorie',
  'po.removeCategory': 'Supprimer la catégorie',
  'po.addCategory': 'Ajouter une catégorie',
  'po.budgetVsSpending': 'Budget et dépenses',
  'po.budgetVsSpendingSub': 'Limite mensuelle par rapport aux dépenses sur la période sélectionnée',
  'po.budgetVsSpendingHelp': 'Budget mensuel par rapport aux dépenses réelles par catégorie. Appuyez sur « Ajuster le budget » pour définir les limites ou créer vos propres catégories. La barre de progression se remplit selon la part du budget utilisée — vert signifie dans les limites, orange proche de la limite, et rouge que la catégorie est dépassée. Si vous choisissez l\'aperçu annuel, la limite mensuelle est multipliée par le nombre de mois disposant de données importées. Les budgets sont enregistrés pour l\'année sélectionnée.',
  'po.whereMoneyGoes': 'Où va l\'argent ?',
  'po.whereMoneyGoesSub': 'Touchez une catégorie pour voir les transactions correspondantes et les déplacer au bon endroit',
  'po.whereMoneyGoesHelp': 'Le graphique circulaire et la liste montrent les dépenses réparties par catégorie pour la période sélectionnée. Changez de période avec le bouton en haut — les mois sans transactions importées sont grisés. Touchez une catégorie pour la mettre en évidence. Le pourcentage à droite est la variation par rapport au mois précédent — vert vers le bas signifie moins, rouge vers le haut signifie plus.',
  'po.selectPeriod': 'Choisir la période',
  'po.yearOverview': 'Aperçu annuel',
  'po.yearly': 'Annuel',
  'po.month.1': 'Janvier',
  'po.month.2': 'Février',
  'po.month.3': 'Mars',
  'po.month.4': 'Avril',
  'po.month.5': 'Mai',
  'po.month.6': 'Juin',
  'po.month.7': 'Juillet',
  'po.month.8': 'Août',
  'po.month.9': 'Septembre',
  'po.month.10': 'Octobre',
  'po.month.11': 'Novembre',
  'po.month.12': 'Décembre',
  'po.largestCategoryIs': 'La plus grande catégorie de dépenses est',
  'po.recurringCharges': 'Prélèvements récurrents à examiner',
  'po.recurringChargesSub': 'Prélèvements d\'abonnement récurrents qui méritent peut-être d\'être vérifiés',
  'po.opportunity': 'Opportunité',
  'po.estimatedAnnualCost': 'Coût annuel estimé',
  'po.saveAccount': 'Enregistrer le compte',
  'po.allAccounts': 'Tous les comptes',
  'po.uploadedStatements': 'Relevés téléversés',
  'po.yourAccounts': 'Vos comptes',
  'po.yourAccountsSub': 'Enregistrez et triez vos comptes par type — les relevés importés sont associés au bon compte',
  'po.totalBalance': 'Solde total',
  'po.creditDebt': 'Dette de carte de crédit',
  'po.accounts': 'Comptes',
  'po.analysis': 'Analyse de SuperPlumma',
  'po.analysisSub': 'Comment les dépenses de la catégorie se répartissent — et ce que vous pouvez faire',
  'po.whoIsBehind': 'Qui se cache derrière',
  'po.noTransactionsToAnalyse': 'Aucune transaction à analyser pour le moment.',
  'po.unusualPurchases': 'Achats inhabituels',
  'po.noUnusualPurchases': 'Aucun achat ne se démarque sur cette période.',
  'po.searchTransactions': 'Rechercher des transactions …',
  'po.clearSearch': 'Effacer la recherche',
  'po.sort': 'Trier',
  'po.linkStatementToAccount': 'Associer le relevé à un compte',
  'po.linkToAccount': 'Associer à un compte',
  'po.newAccount': 'Nouveau compte',
  'po.accountNamePh': 'Ex. DNB compte courant',
  'po.accountNumberPh': 'Ex. 1234.56.78901',
  'po.currentAccount': 'Compte courant',
  'po.creditCard': 'Carte de crédit',
  'po.me': 'moi',
  'po.importTitle': 'Importer des données financières',
  'po.importSub': 'Téléversez des relevés bancaires — SuperPlumma les lit et les catégorise automatiquement',
  'po.pickStatement': 'Choisir un relevé bancaire',
  'po.pickStatementHelp': 'Téléversez les relevés de votre banque. Les fichiers XLSX et CSV sont lus directement, les PDF sont lus au mieux à partir du texte. SuperPlumma catégorise les transactions automatiquement.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'Aucun relevé bancaire n\'a encore été téléversé.',
  'po.deleteStatement': 'Supprimer le relevé',
  'po.sharedCosts': 'Contribution aux dépenses communes',
  'po.sharedCostsSub': 'Qui paie quoi parmi les dépenses communes — et comment cela se compare à la part de revenus',
  'po.sharedCostsHelp': 'La barre montre quelle part des dépenses communes du foyer chacun de vous couvre. À droite figure la part du revenu total. Si les deux sont égales, la répartition est proportionnelle au revenu. Les chiffres proviennent de ce que chacun de vous a saisi dans son propre profil.',
  'po.splitIsEven': 'La répartition est équilibrée. Vous partagez',
  'po.togetherYouCan': 'Ensemble, vous pouvez',
  'po.togetherYouCanSub': 'De petites mesures à prendre en équipe — calculées à partir des propres chiffres du foyer',
  'po.togetherHelp': 'Les suggestions sont calculées à partir du revenu total et des dépenses communes que vous avez saisis. Ce sont des objectifs communs, pas des exigences individuelles.',
  'po.sharedSteps': 'Mesures communes',
  'po.magnitude': 'Ordre de grandeur',
  'po.youPartnerPh': 'Vous, partenaire …',
  'po.monthlyNetIncome': 'Revenu net mensuel',
  'po.sharedCostShare': 'Part des dépenses communes par mois',
  'po.familyFinances': 'Finances familiales',
  'po.addPerson': 'Ajouter une personne',
  'po.noHouseholdMembers': 'Aucun membre du foyer n\'est encore enregistré.',
  'po.householdHasRegistered': 'Le foyer a enregistré',
  'po.todaysPlan': 'Plan du jour',
  'po.savePlan': 'Enregistrer le plan',
  'po.monthlySaving': 'Épargne mensuelle (NOK)',
  'po.monthlyExtraDebt': 'Remboursement anticipé mensuel (NOK)',
  'po.targetNetWealth': 'Patrimoine net souhaité (NOK)',
  'po.expectedReturn': 'Rendement annuel attendu (%)',
  'po.yourAgeToday': 'Votre âge aujourd\'hui (ans)',
  'po.desiredRetirementAge': 'Âge de départ à la retraite souhaité (ans)',
  'po.pickEvent': 'Choisir un événement',
  'po.eventNamePh': 'Ex. Deuxième enfant',
  'po.starts': 'Début',
  'po.oneOffCost': 'Coût ponctuel (NOK)',
  'po.monthlyEffect': 'Effet mensuel (NOK)',
  'po.durationMonths': 'Durée (mois)',
  'po.goalName': 'Nom de l\'objectif',
  'po.goalNamePh': 'Ex. Épargne de précaution',
  'po.shortDescription': 'Brève description',
  'po.whatSavingFor': 'Pour quoi épargnez-vous ?',
  'po.targetAmount': 'Montant cible (NOK)',
  'po.savedSoFar': 'Épargné jusqu\'à présent (NOK)',
  'po.icon': 'Icône',
  'po.colour': 'Couleur',
  'po.debtFree': 'Sans dette',
  'po.saveLoan': 'Enregistrer le prêt',
  'po.loanType': 'Type de prêt',
  'po.spendingCategory': 'Catégorie dans Dépenses',
  'po.categoryPh': 'Ex. Logement',
  'po.debtOverview': 'Aperçu des dettes',
  'po.debtOverviewSub': 'Tous vos prêts réunis — capital restant dû, intérêts et rythme de remboursement',
  'po.debtOverviewHelp': 'Les indicateurs clés de toutes vos dettes : capital restant dû total, ce que vous remboursez par mois, frais d\'intérêts par an, taux moyen et temps restant avant d\'être sans dette.',
  'po.totalDebt': 'Dette totale',
  'po.repaymentPerMonth': 'Remboursement par mois',
  'po.interestPerYear': 'Intérêts par an',
  'po.averageRate': 'Taux moyen',
  'po.debtFreeIn': 'Sans dettes dans',
  'po.loanCount': 'Nombre d\'emprunts',
  'po.yourLoans': 'Vos emprunts',
  'po.yourLoansSub': 'Appuyez sur un emprunt pour voir le plan de remboursement et simuler des changements',
  'po.addLoan': 'Ajouter un emprunt',
  'po.noLoans': 'Aucun emprunt saisi pour l\'instant. Appuyez sur « Ajouter un emprunt » pour commencer.',
  'po.whichLoanFirst': 'Quels emprunts rembourser en premier ?',
  'po.whichLoanFirstSub': 'Classés par taux d\'intérêt — commencer par l\'emprunt le plus cher rapporte le plus pour chaque couronne supplémentaire',
  'po.iRecommend': 'Je recommande',
  'po.snowballWithRate': 'la méthode du taux (méthode avalanche)',
  'po.repaymentSimSub': 'Voyez comment le capital restant dû diminue, et simulez ce qui se passe si vous payez plus ou moins chaque mois',
  'po.myRecommendation': 'Ma recommandation',
  'po.withChange': 'Avec le changement',
  'po.extraRepaymentPerMonth': 'Remboursement supplémentaire par mois',
  'po.dragToPayMore': 'Faites glisser pour payer plus (sans dettes plus tôt) ou moins (durée plus longue)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Intérêts économisés',
  'po.overWholeTerm': 'sur toute la durée',
  'po.netWealthEffect': 'Effet sur le patrimoine net',
  'po.becomesYours': 'vous revient, et non à la banque',
  'po.interestPostedAs': 'Les intérêts et remboursements de cet emprunt sont comptabilisés comme',
  'po.debtJourney': 'Votre parcours de désendettement',
  'po.debtJourneySub': 'Les principales étapes jusqu\'à ne plus avoir aucune dette',
  'po.yourFinancialFuture': 'Votre avenir financier',
  'po.yourFinancialFutureSub': 'Où l\'argent vous mène — et comment vos choix façonnent le chemin',
  'po.showingScenario': 'Scénario affiché :',
  'po.reset': 'Réinitialiser',
  'po.desiredNetWealth': 'Patrimoine net souhaité',
  'po.lastsUntilYouAre': 'dure jusqu\'à vos',
  'po.lasts': 'dure',
  'po.forLife': 'toute la vie',
  'po.plummaReadsChart': 'SuperPlumma lit le graphique',
  'po.whatIf': 'Et si… ?',
  'po.whatIfSub': 'Définissez le point de départ dans le plan actuel, choisissez une décision et ajustez les hypothèses — le graphique, les objectifs, les dates et la retraite se mettent à jour en même temps',
});
